import React from 'react';
import PropTypes from 'prop-types';

import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn, Dot } from '../../companies/companies-components/styles';
import { NameColumn, PositionColumn } from './styles';
import CompaniesContext from '../../companies/companies-components/context';

export default function Contributor({ member }) {
  const {
    slug,
    name,
    position,
    userId,
    cta,
  } = member;

  const { dispatch } = React.useContext(CompaniesContext);

  const showModal = type => e => {
    e && e.preventDefault();

    dispatch({ type, payload: member });
  };

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <PositionColumn>{position}</PositionColumn>
      <ActionColumn>
        <Link href={`/admin/users/${userId}`}>View User</Link>
        |
        <Link href={`/admin/profiles/${slug}`}>View Profile</Link>
        |
        <Link href={`/lwadmin/profile/${slug}/features`}>View Features</Link>
        |
        <Link href="#" onClick={showModal('ctaContributor')}>
          CTA
          { cta && <Dot /> }
        </Link>
      </ActionColumn>
    </RowContainer>
  );
}

Contributor.propTypes = {
  member: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string,
    position: PropTypes.string,
    userId: PropTypes.number,
    cta: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  }).isRequired,
};
